import { Component, OnInit, Injector } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import {
  ProgramDetailsGAService,
  PlantService,
  GateService,
  AuthorizationService,
  DocumentService
} from '../../../../ve.service';
import { FilterableService } from '../../../../filterable-service';

const ACTIVE_ONLY_REQUEST = '?activeOnly=true';

@Component({
  selector: 'ga-add-multiple-form',
  templateUrl: './ga-add-multiple-form.component.html',
  styleUrls: [
    '../../../work-orders.component.scss',
    '../../../../ve.component.scss'
  ]
})
export class GaAddMultipleFormComponent implements OnInit {
  workOrdersService: WorkOrdersService;
  programDetailsService: ProgramDetailsGAService;
  plantService: PlantService;
  gateService: GateService;
  authService: AuthorizationService;
  documentService: DocumentService;

  programsList = new FilterableService();
  plantList = new FilterableService();
  gateList = new FilterableService();
  usersList = new FilterableService();

  architecture: any;
  ergoEngineer: any;
  veLead: any;
  meLead: any;
  gateTargeted: any;

  constructor(injector: Injector) {
    this.workOrdersService = injector.get(WorkOrdersService);
    this.programDetailsService = injector.get(ProgramDetailsGAService);
    this.plantService = injector.get(PlantService);
    this.gateService = injector.get(GateService);
    this.authService = injector.get(AuthorizationService);
    this.documentService = injector.get(DocumentService);
  }

  ngOnInit() {
    this.setRequestDate();
    this.getGateTargeted();

    Promise.all([
      this.getPrograms(),
      this.getGates()
    ]).then(() => {
      if (!this.workOrdersService.isNewWO || this.workOrdersService.isCopyWO) { this.getEditData(); }
    });
  }

  getEditData() {
    const programDetailsId = this.workOrdersService.editData.ProgramDetailId;
    this.getProgramRelatedFields(programDetailsId);
  }

  setRequestDate() {
    const date = new Date();
    this.workOrdersService.gaAddMultipleForm.get('RequestDate').setValue(date);
  }

  getPrograms(): Promise<any> {
    return this.programDetailsService.read(ACTIVE_ONLY_REQUEST)
      .then(response => {
        response = response.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
        this.programsList.next(response);
      });
  }

  getPlants(programId: any): Promise<any> {
    return this.plantService.read('ByProgram/' + programId)
      .then(response => {
        if (!response) { return; }
        response = response.sort((a, b) => a.PlantDescription.localeCompare(b.PlantDescription));
        this.plantList.next(response);
      });
  }

  getGates(): Promise<any> {
    return this.gateService.read(ACTIVE_ONLY_REQUEST)
      .then(response => {
        this.gateList.next(response);
      });
  }


  getGateTargeted() {
    this.gateTargeted = [
      {
        Name: 'Yes',
        Value: true
      },
      {
        Name: 'No',
        Value: false
      }
    ];
  }

  getProgramRelatedFields(programDetailsId: any): Promise<any> {
    if (programDetailsId) {
      return this.programDetailsService.read('/' + programDetailsId)
        .then(response => {
          if (!response) { return; }
          this.getPlants(response.ProgramId);
          this.setProgram(response);
          this.setArchitecture(response);
          this.setErgoEngineer(response);
          this.setVELead(response);
          this.setMELead(response);
        });
    }
    return null;
  }

  onProgramChange(event: any): Promise<any> {
    this.clearProgramRelatedFields();
    const programDetailsId = event;
    return this.getProgramRelatedFields(programDetailsId);
  }

  setProgram(response: any) {
    if (response.ProgramId) {
      this.workOrdersService.gaAddMultipleForm.get('ProgramId').setValue(response.ProgramId);
    }
  }

  setArchitecture(response: any) {
    if (response.ArchitectureId) {
      this.architecture = response.ArchitectureDescription;
      this.workOrdersService.gaAddMultipleForm.get('ArchitectureId').setValue(response.ArchitectureId);
    } else {
      this.architecture = 'None';
    }
  }

  setErgoEngineer(response: any) {
    if (response.ErgoEngineer) {
      this.ergoEngineer = response.ErgorEngineerName;
      this.workOrdersService.gaAddMultipleForm.get('ErgoEngineer').setValue(response.ErgoEngineer);
    } else {
      this.ergoEngineer = 'None';
    }
  }

  setVELead(response: any) {
    if (response.VELead) {
      this.veLead = response.VELeadName;
      this.workOrdersService.gaAddMultipleForm.get('VELead').setValue(response.VELead);
    } else {
      this.veLead = 'None';
    }
  }

  setMELead(response: any) {
    if (response.MELead) {
      this.meLead = response.MELeadName;
      this.workOrdersService.gaAddMultipleForm.get('MELead').setValue(response.MELead);
    } else {
      this.meLead = 'None';
    }
  }

  clearProgramRelatedFields() {
    this.architecture = null;
    this.ergoEngineer = null;
    this.veLead = null;
    this.meLead = null;
    this.plantList.next(null);

    this.workOrdersService.gaAddMultipleForm.get('ArchitectureId').setValue(null);
    this.workOrdersService.gaAddMultipleForm.get('ErgoEngineer').setValue(null);
    this.workOrdersService.gaAddMultipleForm.get('VELead').setValue(null);
    this.workOrdersService.gaAddMultipleForm.get('MELead').setValue(null);
    this.workOrdersService.gaAddMultipleForm.get('PlantId').setValue(null);
  }
}
